import React from 'react';
import ImageComparisonSlider from 'components/digitalNomad/ImageComparisonSlider';
import { ImageComparisonList, ImageComparison } from 'components/digitalNomad/PhotoEditingPortfolio.style.js';

const PhotoEditingPortfolio = (props) => {
  return (
    <ImageComparisonList>
      <ImageComparison>
        <ImageComparisonSlider sliderStart={50}
          srcBefore='assets/digitalNomad/photo-editing/halong-bay-before.jpg'
          srcAfter='assets/digitalNomad/photo-editing/halong-bay-after.jpg' />
      </ImageComparison>
      <ImageComparison>
        <ImageComparisonSlider sliderStart={50}
          srcBefore='assets/digitalNomad/photo-editing/outback-sunset-before.jpg'
          srcAfter='assets/digitalNomad/photo-editing/outback-sunset-after.jpg' />
      </ImageComparison>
      <ImageComparison>
        <ImageComparisonSlider sliderStart={50}
          srcBefore='assets/digitalNomad/photo-editing/fly-rod-before.jpg'
          srcAfter='assets/digitalNomad/photo-editing/fly-rod-after.jpg' />
      </ImageComparison>
      <ImageComparison>
        <ImageComparisonSlider sliderStart={50}
          srcBefore='assets/digitalNomad/photo-editing/bouldering-before.jpg'
          srcAfter='assets/digitalNomad/photo-editing/bouldering-after.jpg' />
      </ImageComparison>
    </ImageComparisonList>
  );
};

export default PhotoEditingPortfolio;



// WEBPACK FOOTER //
// ./src/components/digitalNomad/PhotoEditingPortfolio.js